<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/21/news_01.jpg'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【 TSK | AMWC Asia-TDAC 】',
      //內文
      description:
        ' <b> TSK Workshop｜2026 AMWC Asia-TDAC </b> <br>誠摯邀請您參與由 TSK Taiwan 主辦 2026 AMWC Asia-TDAC 工作坊，匯聚國內頂尖醫師，分享最新醫美注射技術與臨床經驗，深入探討安全性與精準度兼具的治療策略。<br><br>日期｜ 2026/5/2(六)<br>時間｜ 12:30 – 13:30<br>地點｜ 台北國際會議中心（TICC）三樓北軒（North Lounge – Level 3）<br><br><b>講師陣容</b><br><b>Moderator｜張長正 醫師（CHANG Chang-Cheng, MD PH.D FACS）</b><br><br><b>Speaker｜梁仲斌 醫師（Liang,Ben,Chung-Pin, MD）</b><br>講題： Cannula Injection Revisited: Six Principles for Safer and More Predictable Facial Rejuvenation<br>重新探討鈍針注射六大原則，提升臉部年輕化療程的安全性與可預測性。<br><br><b>Speaker｜楊仕安 醫師（YANG Shih-An, MD）</b><br>講題： From Precise Injection to Optimal Outcomes: Device Selection Strategies in Aesthetic Practice<br>從精準注射到最佳療效：醫美臨床中的器械選擇策略。<br><br>參加 TSK 工作坊即可獲得 價值千元專屬禮盒<br><br><b>TSK 攤位資訊</b><br><b>1 樓 Booth A23</b><br><b>4 樓 Booth D53</b><br><br>誠摯邀請各位醫師與醫美專業人士蒞臨參與，掌握最新臨床趨勢，體驗 TSK 精準工藝所帶來的專業價值。',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
